// Opening a specific workspace item (a step or an insight) from anywhere.
// MyWorkspace reads the staged item on mount and also listens for the event
// when it is already on screen (e.g. the studio's "Captured with" links).

export type WorkspaceItemSection = "action_items" | "insights";

export const WORKSPACE_FOCUS_ITEM_KEY = "workspace_focus_item";
export const WORKSPACE_OPEN_ITEM_EVENT = "workspace-open-item";

export const sectionForTakeaway = (type: string | undefined): WorkspaceItemSection =>
  type === "action" ? "action_items" : "insights";

export function stageWorkspaceItem(section: WorkspaceItemSection, itemId: string): void {
  try {
    sessionStorage.setItem(WORKSPACE_FOCUS_ITEM_KEY, itemId);
    localStorage.setItem("workspace_active_tab", section);
    localStorage.setItem("portal_active_tab", "my_workspace");
  } catch {
    /* storage blocked: the workspace still opens, just not on the item */
  }
  window.dispatchEvent(new CustomEvent(WORKSPACE_OPEN_ITEM_EVENT, { detail: { section, itemId } }));
  window.dispatchEvent(new CustomEvent("portal-tab-change", { detail: "my_workspace" }));
}

/** Read and clear the staged item (one use). */
export function takeWorkspaceItem(): string | null {
  try {
    const id = sessionStorage.getItem(WORKSPACE_FOCUS_ITEM_KEY);
    sessionStorage.removeItem(WORKSPACE_FOCUS_ITEM_KEY);
    return id || null;
  } catch {
    return null;
  }
}
